import { render, staticRenderFns } from "./HighSchoolList.vue?vue&type=template&id=68a781fb&"
import script from "./HighSchoolList.vue?vue&type=script&lang=js&"
export * from "./HighSchoolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports